import styled from "@emotion/styled";
import { SMALL_SCREENS } from "../constants/style_constants";

export const MobileOnly = styled.div({
  display: 'none',
  [SMALL_SCREENS]: {
    display: 'block',
  },
})

export const StationaryOnly = styled.div({
  display: 'block',
  [SMALL_SCREENS]: {
    display: 'none',
  },
})
